import { FC, useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import liff from '@line/liff';

import { useClearCard } from 'hooks/useClearCard';

import { Dialog } from 'components/parts/Dialog';
import CloseIcon from 'images/icon/close_cocoa.svg';
import mapCardReceivingPlace from 'images/icon/map_card-receiving-place.svg';
import { useGetProgressQuery } from 'store/progress';

import styles from '../Card.module.scss';

import { CardItem } from 'components/pages/Card/model/types';
import { useMissionClearCard } from 'hooks/useMissionClearCard';

type Props = {
  card: CardItem;
  handleClose: () => void;
};

export const CardReceiveDialogView: FC<Props> = ({ card, handleClose }) => {
  const navigate = useNavigate();
  const { refetch: refetchProgress } = useGetProgressQuery();
  const { postClearCard } = useClearCard();
  const { postMissionClearCard } = useMissionClearCard();

  // 臨時発見報告所があるかどうか（=発見報告所が2つ以上ある場合）
  const hasTemporaryReceivingPlace = card?.receivingPlace && card.receivingPlace.length >= 2;

  // POSTとrefetchProgressをテストする関数
  // const handleScanQrCodeA = async (id: string) => {
  //   console.log('POST開始');
  //   await postClearCard(Number(id));
  //   console.log('POST終了');
  //   await refetchProgress();
  //   console.log('refetchProgress終了');
  //   navigate(`/card/success/${id}`);
  // };

  const handleScanQrCode = useCallback(
    async (scanCode: string | undefined) => {
      try {
        const scanResult = await liff.scanCodeV2();
        const { value } = scanResult;

        if (value === scanCode) {
          if (card.type === 'area') {
            await postClearCard(card.areaNo);
            await refetchProgress();
            navigate(`/card/success/${card.areaNo}`);
          } else {
            await postMissionClearCard(card.missionNo);
            await refetchProgress();
            navigate(`/card/success/${card.missionNo}`);
          }
        } else {
          navigate(`/card/failure`);
        }
      } catch (error) {
        console.error(error);
      }
    },
    [navigate, card, postClearCard, refetchProgress]
  );

  return (
    <Dialog
      isOpen={true}
      addClass={[styles.dialogApply]}
      handleClose={handleClose}
      easyCloseMode={false}
    >
      <div className={styles.dialogApplyCard}>
        <div className={styles.dialogApplyCardHead}>
          <button
            type="button"
            className={styles.dialogCloseIconButton}
            onClick={() => handleClose()}
          >
            <img src={CloseIcon} alt="閉じる" className={styles.dialogCloseIcon} />
          </button>
          <p className={styles.dialogApplyCardTitle}>実物のカードを受け取る</p>
          <p className={styles.dialogApplyCardLead}>
            報告所に行って二次元コードを読み込むと、
            <br />
            実物のカードが受け取れるよ！
          </p>
        </div>
        <div className={styles.dialogApplyCardBody}>
          <div className={styles.dialogApplyCardContents}>
            {card.name && (
              <div className={styles.dialogApplyCardText1}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: String(card.name).replace(
                      /<ruby>(.*?)<rp>.*?<\/rp><rt>.*?<\/rt><rp>.*?<\/rp><\/ruby>/g,
                      '$1'
                    ),
                  }}
                />
                <span>の発見報告所</span>
              </div>
            )}
            {card.receivingPlace && card.receivingPlace[0].name && (
              <p
                className={styles.dialogApplyCardText2}
                dangerouslySetInnerHTML={{
                  __html: card.receivingPlace[0].name,
                }}
              />
            )}
            {card.receivingPlace && card.receivingPlace[0].mapUrl && (
              <a
                href={card.receivingPlace[0].mapUrl}
                target="_blank"
                rel="noreferrer"
                className={styles.dialogApplyCardMap}
              >
                <img
                  src={mapCardReceivingPlace}
                  alt="MAP"
                  className={styles.dialogApplyCardMapIcon}
                />
              </a>
            )}
          </div>

          {hasTemporaryReceivingPlace && (
            <p className={styles.dialogApplyCardAnnotation}>
              ※休業日の場合、臨時発見報告所をご利用ください。
            </p>
          )}
        </div>

        <div className={styles.dialogApplyCardFoot}>
          {card?.scanCode && (
            <button
              onClick={() => handleScanQrCode(card?.scanCode)}
              type="button"
              className={styles.dialogApplyCardActionButton}
            >
              二次元コードを読み取る
            </button>
          )}
        </div>
      </div>
      {/* {selectedCard.id && (
        <Button
          text="受け取り状態にする"
          styleType="ghost"
          handleClick={() => handleScanQrCodeA(selectedCard.id)}
        ></Button>
      )} */}
    </Dialog>
  );
};
